// import React, { useState, useEffect } from "react";
// import "./Project.scss";
// import ProjectCard from "./Card";
// import {
//   projectData,
//   primaryFilterOptions,
//   secondaryFilterOptions,
// } from "./Data";

// const Filters = () => {
//   const [primaryFilter, setPrimaryFilter] = useState("All");
//   const [secondaryFilter, setSecondaryFilter] = useState("All");
//   const [projectBenefits, setProjectBenefits] = useState({
//     extremeRainfall: false,
//     extremeHeat: false,
//     seaLevelRise: false,
//   });
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filteredProjects, setFilteredProjects] = useState(projectData);

//   useEffect(() => {
//     applyFilters();
//   }, [primaryFilter, secondaryFilter, projectBenefits, searchQuery]);

//   const applyFilters = () => {
//     let filtered = [...projectData];

//     if (primaryFilter !== "All") {
//       filtered = filtered.filter(
//         (project) => project.primary === primaryFilter
//       );
//     }

//     if (secondaryFilter !== "All") {
//       filtered = filtered.filter(
//         (project) => project.secondary === secondaryFilter
//       );
//     }

//     const activeBenefits = Object.keys(projectBenefits).filter(
//       (key) => projectBenefits[key]
//     );

//     if (activeBenefits.length > 0) {
//       filtered = filtered.filter((project) =>
//         activeBenefits?.every((benefit) =>
//           project.benefits?.includes(benefit.trim())
//         )
//       );
//     }

//     if (searchQuery.trim() !== "") {
//       const regex = new RegExp(searchQuery.trim(), "i");

//       filtered = filtered.filter(
//         (project) =>
//           regex.test(project?.title?.toString() || "") ||
//           regex.test(project?.description?.toString() || "") ||
//           regex.test(project?.beneficiaries?.toString() || "") ||
//           regex.test(project?.impact?.toString() || "") ||
//           regex.test(project?.cost?.toString() || "")
//       );
//     }

//     setFilteredProjects(filtered);
//   };

//   const handleCheckboxChange = (benefit) => {
//     setProjectBenefits({
//       ...projectBenefits,
//       [benefit]: !projectBenefits[benefit],
//     });
//   };

//   return (
//     <>
//       <div className="filters-container">
//         <div className="search-projects">
//           <div className="search-container">
//             <input
//               type="text"
//               placeholder="Search for projects"
//               className="search-input"
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//             />
//             <button className="search-button">🔍</button>
//           </div>
//           <div className="filters-section">
//             <h4>Filters</h4>
//             <div className="dropdowns">
//               <div className="dropdown">
//                 <label className="dropdown-label">Bankability</label>
//                 <select
//                   value={primaryFilter}
//                   onChange={(e) => setPrimaryFilter(e.target.value)}
//                 >
//                   {primaryFilterOptions.map((option) => (
//                     <option key={option} value={option}>
//                       {option}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//               <div className="dropdown">
//                 <label className="dropdown-label">Project Archetypes</label>
//                 <select
//                   value={secondaryFilter}
//                   onChange={(e) => setSecondaryFilter(e.target.value)}
//                 >
//                   {secondaryFilterOptions.map((option) => (
//                     <option key={option} value={option}>
//                       {option}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="project-benefits-section">
//           <h4>Project Benefits</h4>
//           <div className="benefits">
//             <label>
//               <input
//                 type="checkbox"
//                 checked={projectBenefits.extremeRainfall}
//                 onChange={() => handleCheckboxChange("extremeRainfall")}
//               />
//               Extreme Rainfall
//             </label>
//             <label>
//               <input
//                 type="checkbox"
//                 checked={projectBenefits.extremeHeat}
//                 onChange={() => handleCheckboxChange("extremeHeat")}
//               />
//               Extreme Heat
//             </label>
//             <label>
//               <input
//                 type="checkbox"
//                 checked={projectBenefits.seaLevelRise}
//                 onChange={() => handleCheckboxChange("seaLevelRise")}
//               />
//               Sea Level Rise
//             </label>
//           </div>
//         </div>
//       </div>
//       <div className="card-container">
//         <p className="total-cards">
//           Showing {filteredProjects.length}/{projectData.length} results
//         </p>

//         <div className="project-list">
//           {filteredProjects.map((project) => (
//             <ProjectCard key={project.id} project={project} />
//           ))}
//         </div>
//       </div>
//     </>
//   );
// };

// export default Filters;

import React, { useState, useEffect } from "react";
import "./Project.scss";
import ProjectCard from "./Card";
import {
  projectData,
  primaryFilterOptions,
  secondaryFilterOptions,
} from "./Data";
import { useLocation } from "react-router-dom";
import search from "../../assets/images/search.png";
const Filters = () => {
  const location = useLocation();
  const [primaryFilter, setPrimaryFilter] = useState(0);
  const [secondaryFilter, setSecondaryFilter] = useState(0);
  const [projectBenefits, setProjectBenefits] = useState({
    extremeRainfall: false,
    extremeHeat: false,
    seaLevelRise: false,
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredProjects, setFilteredProjects] = useState(projectData);
  useEffect(() => {
    const searchParams = new URLSearchParams(location?.search);
    const secondaryFromURL = decodeURIComponent(
      location?.pathname?.split("/")?.pop() || ""
    );
    const matchingOption = secondaryFilterOptions?.find(
      (option) => option?.name === secondaryFromURL
    );
    if (matchingOption) {
      setSecondaryFilter(matchingOption?.id);
    } else {
      setSecondaryFilter(0);
    }
  }, [location]);
  useEffect(() => {
    applyFilters();
  }, [primaryFilter, secondaryFilter, projectBenefits, searchQuery]);

  const applyFilters = () => {
    let filtered = [...projectData];
    if (primaryFilter !== 0) {
      filtered = filtered.filter(
        (project) => project?.primary === primaryFilter
      );
    }

    if (secondaryFilter !== 0) {
      filtered = filtered.filter(
        (project) => project?.secondary === secondaryFilter
      );
    }

    const activeBenefits = Object.keys(projectBenefits).filter(
      (key) => projectBenefits[key]
    );

    if (activeBenefits.length > 0) {
      filtered = filtered.filter((project) =>
        activeBenefits?.every((benefit) =>
          project.benefits?.includes(benefit.trim())
        )
      );
    }

    if (searchQuery.trim() !== "") {
      const regex = new RegExp(searchQuery.trim(), "i");

      filtered = filtered.filter(
        (project) =>
          regex.test(project?.title?.toString() || "") ||
          regex.test(project?.description?.toString() || "") ||
          regex.test(project?.beneficiaries?.toString() || "") ||
          regex.test(project?.impact?.toString() || "") ||
          regex.test(project?.cost?.toString() || "")
      );
    }

    setFilteredProjects(filtered);
  };

  const handleCheckboxChange = (benefit) => {
    setProjectBenefits({
      ...projectBenefits,
      [benefit]: !projectBenefits[benefit],
    });
  };

  return (
    <>
      <div className="filters-container">
        <div className="search-projects">
          <div className="search-container">
            <input
              type="text"
              placeholder="Search for projects"
              className="search-input"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button className="search-button">
              <img src={search} alt="search" className="search-img" />
            </button>
          </div>
          <div className="filters-section">
            <h4>Filters</h4>
            <div className="dropdowns">
              <div className="dropdown">
                <label className="dropdown-label">Bankability</label>
                <select
                  value={primaryFilter}
                  onChange={(e) => setPrimaryFilter(Number(e.target.value))}
                >
                  {primaryFilterOptions?.map((option) => (
                    <option key={option?.id} value={option?.id}>
                      {option?.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="dropdown">
                <label className="dropdown-label">Project Archetypes</label>
                <select
                  value={secondaryFilter}
                  onChange={(e) => setSecondaryFilter(Number(e.target.value))}
                >
                  {secondaryFilterOptions?.map((option) => (
                    <option key={option?.id} value={option?.id}>
                      {option?.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="project-benefits-section">
          <h4>Project Benefits</h4>
          <div className="benefits">
            <label>
              <input
                type="checkbox"
                checked={projectBenefits.extremeRainfall}
                onChange={() => handleCheckboxChange("extremeRainfall")}
              />
              Extreme Rainfall
            </label>
            <label>
              <input
                type="checkbox"
                checked={projectBenefits.extremeHeat}
                onChange={() => handleCheckboxChange("extremeHeat")}
              />
              Extreme Heat
            </label>
            <label>
              <input
                type="checkbox"
                checked={projectBenefits.seaLevelRise}
                onChange={() => handleCheckboxChange("seaLevelRise")}
              />
              Sea Level Rise
            </label>
          </div>
        </div>
      </div>
      <div className="card-container">
        <p className="total-cards">
          Showing {filteredProjects.length}/{projectData.length} results
        </p>

        <div className="project-list">
          {filteredProjects.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>
      </div>
    </>
  );
};

export default Filters;
